/* eslint-disable no-global-assign */

let overrideDoc = false;

if (typeof document === 'undefined') {
  overrideDoc = true;
  document = {
    body: {
      appendChild() { },
    },
    set cookie(value) {
      if (value) {
        document._cookie = `${document._cookie}; ${value}`;
      }
    },
    get cookie() {
      return document._cookie;
    },
    _cookie: '',
    addEventListener() {},
    removeEventListener() {},
    activeElement: {
      blur() {},
      nodeName: '',
    },
    querySelector() {
      return null;
    },
    querySelectorAll() {
      return [];
    },
    getElementById() {
      return null;
    },
    createEvent() {
      return {
        initEvent() {},
      };
    },
    createElement() {
      return {
        children: [],
        childNodes: [],
        style: {},
        setAttribute() {},
        getElementsByTagName() {
          return [];
        },
      };
    },
    location: { hash: '' },
    documentElement: {
      classList: {
        add() {},
        remove() {},
      },
      setAttribute() { },
    },
    appendChild() { },
  };
}

if (typeof window === 'undefined') {
  window = {
    isServer: true,
    document,
    navigator: {
      userAgent: '',
    },
    location: {
      href: '',
      replace() {},
    },
    history: {},
    CustomEvent: function CustomEvent() {
      this.initCustomEvent = function () {};
      return this;
    },
    dispatchEvent() {},
    addEventListener() {},
    removeEventListener() {},
    getComputedStyle() {
      return {
        getPropertyValue() {
          return '';
        },
      };
    },
    Image() {},
    Date() {},
    screen: {},
    setTimeout() {},
    clearTimeout() {},
    scrollTo() { },
    matchMedia() {
      return {
        matches: false,
      }
    }
  };

  global.CustomEvent = function CustomEvent() {
    this.initCustomEvent = function () {};

    return this;
  };

  global.Node = {};
}

if (typeof navigator === 'undefined') {
  navigator = {
    userAgent: ''
  };
}

if (overrideDoc) {
  document.defaultView = window;
}

if (typeof FormData === 'undefined') {
  class FormDataDef {}
  FormData = FormDataDef;
}

if (typeof addEventListener === 'undefined') {
  addEventListener = function () {};
}
